module.exports = ["CTServiceAPI", "AppConstants", function(CTServiceAPI, AppConstants) {

    const CommitmentModel = function(data) {
        data.state = data.state || 0;
        
        this.__setData(data);
    };

    CommitmentModel.prototype = {
        update(data) {
            return CTServiceAPI.put(`/pages/${AppConstants.PAGE_ID}/commitments/${this.person_id}`, data)
                               .then((data) => this.__setData(data.commitment));
        },

        blockPerson() {
            return CTServiceAPI.post(`/people`, {id: this.person.id, blocked: true});
        },

        __setData(data) {
            angular.extend(this, data);
        }
    };

    return (data) => new CommitmentModel(data);
}];
